module.exports = __webpack_public_path__ + "static/media/animal-dog6.dfa7f890.aac";